import enBundle from "./docs.generated.json";
import frBundle from "./docs.generated.fr.json";
import type { Lang } from "../i18n";

export interface DocArticle {
  slug: string;
  guide: string;
  guideTitle: string;
  section: string;
  sectionTitle: string;
  title: string;
  who: string;
  where: string;
  requires: string;
  summary: string;
  body: string;
  order: number;
}

export interface DocSection {
  key: string;
  title: string;
  slugs: string[];
}

export interface DocGuide {
  key: string;
  title: string;
  sections: DocSection[];
}

interface Bundle {
  guides: DocGuide[];
  articles: DocArticle[];
}

interface LangData {
  guides: DocGuide[];
  articles: DocArticle[];
  bySlug: Map<string, DocArticle>;
}

function build(bundle: Bundle): LangData {
  const articles = bundle.articles as DocArticle[];
  return {
    guides: bundle.guides as DocGuide[],
    articles,
    bySlug: new Map(articles.map((a) => [a.slug, a])),
  };
}

const data: Record<Lang, LangData> = {
  en: build(enBundle as unknown as Bundle),
  fr: build(frBundle as unknown as Bundle),
};

export function getGuides(lang: Lang): DocGuide[] {
  return data[lang].guides;
}

export function allArticles(lang: Lang): DocArticle[] {
  return data[lang].articles;
}

export function getArticle(lang: Lang, slug: string): DocArticle | null {
  return data[lang].bySlug.get(slug) ?? null;
}

export function getArticleTitle(lang: Lang, slug: string): string {
  return data[lang].bySlug.get(slug)?.title ?? slug;
}
